import { useNavigate } from "react-router-dom";
import { Reveal } from "./motion";

export default function ClosingCta() {
  const navigate = useNavigate();
  return (
    <section
      data-testid="closing-cta"
      className="px-6 md:px-12 py-36 md:py-56 border-t border-verlo/10 bg-verlo"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-brass mb-10">
            Built for restaurants
          </p>
          <h2 className="font-display font-light text-4xl sm:text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[1.1] text-paper max-w-4xl text-balance">
            Not adapted. Not rebranded. Not retrofitted. Designed from day one around
            hospitality.
          </h2>
        </Reveal>
        <Reveal>
          <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-6">
            <button
              data-testid="closing-try-verlo"
              onClick={() => navigate("/sandbox")}
              className="inline-flex items-center bg-brass text-verlo font-medium text-base md:text-lg px-9 py-4 rounded-full hover:bg-paper transition-colors duration-300"
            >
              Try Verlo
            </button>
            <a
              data-testid="closing-book-demo"
              href="mailto:hello@verlohq.com"
              className="inline-flex items-center border border-paper/30 text-paper font-medium text-base md:text-lg px-9 py-4 rounded-full hover:bg-paper/10 transition-colors duration-300"
            >
              Book a demo
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
